<template>
  <Icon :icon="path" :data-icon="path" />
</template>

<script setup lang="ts">
import {
  FUNCTION_ICON_ASSET_NAMES,
  resolveFunctionIconAssetName,
} from '~/config/functionIcons'

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
})

const basePath = 'function-icons'
const iconName = resolveFunctionIconAssetName(props.icon)
const iconPath = (FUNCTION_ICON_ASSET_NAMES as readonly string[]).includes(
  iconName,
)
  ? iconName
  : 'default'
const joinPath = (...paths: string[]) => {
  return paths.map((p) => p.replace(/^\/|\/$/, '')).join('/')
}
const path = joinPath(basePath, iconPath)
</script>
